import {useContext, useEffect, useState} from 'react';
import {END} from 'redux-saga';

import {AppContext} from '../app_context';
import {setterChannel} from './channels';

let nextKey = 1;
function getNextKey() {
    const result = nextKey.toString();
    nextKey++;
    return result;
}

function feedbackChannel(setter) {
    let busy = 0;
    let error = null;
    return setterChannel((message) => {
        if (message === END) {
            return;
        }
        if ('busy' in message) {
            if (message.busy) {
                busy++;
            } else {
                busy--;
            }
        }
        if ('error' in message) {
            error = message.error;
        }
        setter({ busy: busy > 0, error });
    });
}

function useFeedback(visual=false) {
    const [key] = useState(getNextKey);
    const [{busy, error}, setFeedback] = useState({ busy: false, error: null });
    const { mergeFeedback } = useContext(AppContext);
    const [feedbackCh] = useState(() => feedbackChannel((value) => {
        setFeedback(value);
        if (typeof mergeFeedback === 'function') {
            mergeFeedback(key, { ...value, visual });
        }
    }));
    useEffect(() => {
        return () => {
            feedbackCh.close();
            if (typeof mergeFeedback === 'function') {
                mergeFeedback(key, null);
            }
        };
    }, [feedbackCh, key, mergeFeedback]);
    return {busy, error, channel: feedbackCh, feedbackCh};
}

export default useFeedback;
